/**
 * This function changes the url using replaceState API, wich operates as history.pushState() exept
 * that it modifies the current history entry instead of creating a new one
 * @param {String} toAppend url to replace in the browser history
 */
export const changeUrlNoHistory = (toAppend) => {
  history.replaceState(null, null, toAppend);
};

/**
 * This function changes the url using the pushState API creating a new history entry in the
 * history stack
 * @param {String} toAppend url to add to the browser history
 */
export const changeUrlAndHistory = (toAppend) => {
  history.pushState(null, null, toAppend);
};

/**
 * Removes a specific query parameter from the current URL
 * and update the history
 * @param {string} key - The query parameter key to remove
 */
export const removeQueryParam = (key) => {
  const urlObj = new URL(window.location.origin + window.location.pathname);
  urlObj.searchParams.delete(key);
  const updatedUrl = urlObj.toString();
  changeUrlNoHistory(updatedUrl);
};

/**
 * Appends or updates a query parameter in the current URL
 * @param {string} key - The query parameter key
 * @param {string|number} value - The query parameter value
 * @returns {string} - The updated URL
 */
export const setQueryParam = (key, value) => {
  const urlObj = new URL(window.location.origin + window.location.pathname);
  urlObj.searchParams.set(key, value);
  const updatedUrl = urlObj.toString();
  changeUrlAndHistory(updatedUrl);
  return updatedUrl;
};

/**
 * Retrieves the value of a query parameter from the current URL
 * @param {string} key - The query parameter key
 * @returns {string|null} - The value of the query parameter or null if not found
 */

export const getQueryParam = (key) => {
  const urlObj = new URL(window.location.origin + window.location.pathname + window.location.search);
  return urlObj.searchParams.get(key);
};
